// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const TextToImageIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'text-to-image'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 6.5C12.2521 6.5 12.4989 6.5663 12.7158 6.69043L12.8066 6.74707L12.8926 6.80957C13.0884 6.96391 13.2403 7.16644 13.335 7.39648L16.9248 16.1191C17.1349 16.6298 16.8914 17.2146 16.3809 17.4248C15.8702 17.6349 15.2854 17.3914 15.0752 16.8809L14.2188 14.7998H9.78125L8.9248 16.8809C8.71453 17.3914 8.12979 17.635 7.61914 17.4248C7.10856 17.2145 6.86502 16.6298 7.0752 16.1191L10.665 7.39648C10.7732 7.13382 10.957 6.90732 11.1943 6.74707C11.4318 6.58679 11.7122 6.50009 12 6.5ZM10.6045 12.7998H13.3965L12 9.40625L10.6045 12.7998Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 2C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H19ZM5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44771 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44771 19.5523 4 19 4H5Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
TextToImageIcon.displayName = 'TextToImageIcon'
export { TextToImageIcon }
